import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addBanner } from 'slice/bannerSlice';

const AddBanner = () => {
    const [formData, setFormData] = useState({
        heading: '',
        sub_heading: '',
        image: null,
    });

    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.banner); // Fixed from state.product
    const navigate = useNavigate()

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.heading || !formData.image) {
            toast.error('Heading and Image are required');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('heading', formData.heading);
        formDataToSend.append('sub_heading', formData.sub_heading);
        formDataToSend.append('image', formData.image);

        try {
            dispatch(addBanner(formDataToSend))
            toast.success('Banner added successfully!')
            navigate('/banner')
        } catch (error) {
            console.error('There was a problem adding the banner:', error.message);
            toast.error('Failed to add banner');
        }
    };

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4'>
                    <h4 className="text-white font-weight-bold">Add Banner</h4>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className='row mx-4'>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerHeading' className='adminlables'>Banner Heading</label>
                            <input type='text' id='bannerHeading' name='heading' value={formData.heading} className='form-control' placeholder="Enter main heading (e.g. Modern Architecture)" onChange={handleChange} required />
                </div>
                <div className='col-sm-12 mt-4'>
                    <label htmlFor='bannerSubHeading' className='adminlables'>Banner Sub Heading</label>
                    <input type='text' id='bannerSubHeading' name='sub_heading' value={formData.sub_heading} className='form-control' placeholder="Enter sub-heading (e.g. Building your dreams)" onChange={handleChange} />
                </div>
                <div className='col-sm-12 mt-4'>
                    <label htmlFor='bannerImage' className='adminlables'>Banner Image</label>
                    <input type='file' id='bannerImage' name='image' className='form-control btn-block filebg' onChange={handleChange} required />
                </div>
            </div>
            <div className='mt-4 text-right mx-4 '>
                <button className='btn btn-lg addbtn' disabled={loading}>
                    {loading ? 'Adding...' : 'Add Banner'}
                </button>
            </div>
        </form >
            </div >
        </>
    )
}

export default AddBanner